import { SITE, TARGET_KEYWORDS } from './site';
import { absoluteUrl } from './routes';

export function buildOrganizationSchema() {
  return {
    '@type': 'ProfessionalService',
    '@id': `${SITE.url}/#organization`,
    name: SITE.brand,
    alternateName: ['SAAD Informatique', 'Richard SAAD Consultant Informatique'],
    url: SITE.url,
    logo: SITE.defaultImage,
    image: SITE.defaultImage,
    description:
      'Consultant informatique indépendant à Lyon et dans le Rhône : infogérance, dépannage, infrastructure, sécurité et Microsoft 365 pour TPE et PME.',
    email: SITE.email,
    areaServed: [
      { '@type': 'City', name: 'Lyon' },
      { '@type': 'AdministrativeArea', name: 'Rhône' },
      { '@type': 'AdministrativeArea', name: 'Auvergne-Rhône-Alpes' },
      { '@type': 'Country', name: 'France' },
    ],
    address: {
      '@type': 'PostalAddress',
      addressLocality: SITE.addressLocality,
      addressRegion: SITE.addressRegion,
      postalCode: SITE.postalCode,
      addressCountry: SITE.addressCountry,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: SITE.geo.latitude,
      longitude: SITE.geo.longitude,
    },
    priceRange: '€€',
    knowsAbout: TARGET_KEYWORDS.slice(0, 12),
    founder: {
      '@type': 'Person',
      name: 'Richard SAAD',
      jobTitle: 'Consultant informatique indépendant',
    },
    sameAs: [],
  };
}

export function buildWebSiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': `${SITE.url}/#website`,
    url: SITE.url,
    name: SITE.brand,
    description:
      'Site officiel de SAAD Informatique — consultant informatique à Lyon et Rhône.',
    inLanguage: 'fr-FR',
    publisher: { '@id': `${SITE.url}/#organization` },
  };
}

/**
 * @param {{ name: string, path: string }[]} items
 */
export function buildBreadcrumbSchema(items) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

/**
 * @param {string} pathname
 * @param {{ title: string, description: string }} seo
 */
export function buildServiceSchema(pathname, seo) {
  return {
    '@type': 'Service',
    name: seo.title.split('|')[0].trim(),
    description: seo.description,
    url: absoluteUrl(pathname),
    provider: { '@id': `${SITE.url}/#organization` },
    areaServed: {
      '@type': 'AdministrativeArea',
      name: 'Lyon et Rhône',
    },
    serviceType: 'Services informatiques pour entreprises',
  };
}
